import { supabase } from "../../supabaseClient"

export const saveServiceType = async (id = undefined, item) => {
    if (id) {
        return await supabase
            .from('ServiceTypes')
            .update({ ...item })
            .match({ id })
    } else {
        return await supabase
            .from('ServiceTypes')
            .insert([{ ...item }])
    }
}